import { Link } from "react-router-dom";
import { FaCartPlus } from "react-icons/fa";

import Button from "../components/Button";
import product5Image from "../assets/images/product5.png";
import styled from "styled-components";

const ProductCard = () => {
  return (
    <div className="mb-12 xs:w-full sm:w-1/2 md:w-1/3 lg:w-1/4">
      <div className="product-card-wrapper">
        <Link to="product">
          <HoveredProductCard className="group flex flex-col justify-center hover:bg-[#f7f7f7] pb-8">
            <div className="image transition-all duration-200 h-2/3">
              <img src={product5Image} alt="" />
            </div>
            <div className="overflow-hidden flex-auto">
              <div className="details px-3 transition-all duration-300 group-hover:opacity-0">
                <div className="name text-base text-[#777e86] flex justify-center text-center">
                  <h4>Grenade Carb Killa Protein Bar</h4>
                </div>
                <div className="price flex justify-center pt-2 pb-4 text-lg text-[#535860] font-medium">
                  <span className="">$14.50</span>
                </div>
              </div>
              <div className="add-to-cart flex justify-center transition-all duration-300 opacity-0 group-hover:opacity-100">
                <Button isHovered={false} width="w-auto">
                  <p className="flex items-center text-[12px]">
                    <span className="">
                      <FaCartPlus />
                    </span>
                    <span className="pl-2">Add to Cart</span>
                  </p>
                </Button>
              </div>
            </div>
          </HoveredProductCard>
        </Link>
      </div>
    </div>
  );
};

const HoveredProductCard = styled.div`
  .details {
    transform: translateY(50%);
  }

  .add-to-cart {
    transform: translateY(100%);
  }

  &:hover .image {
    transform: translateY(8px);
  }

  &:hover .details,
  &:hover .add-to-cart {
    transform: translateY(-100%);
  }
`;
export default ProductCard;
